import {useInfiniteQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {httpGetHeadquarters, HttpGetFilterResponse} from '@/features/measures/services/measures.http.ts'

export const useGetHeadquarters = (searchQuery: string) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.HEADQUARTERS, searchQuery],
        queryFn: ({pageParam = 1}) =>
            parseAxiosPromise({
                axiosPromise: httpGetHeadquarters({page: pageParam, search: searchQuery}),
                responseShape: HttpGetFilterResponse,
                onZodError: captureException
            }),
        initialPageParam: 1,
        getNextPageParam: ({meta}) => meta && (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    const remappedData = query.data?.pages.flatMap(page => page.data) || []

    return {
        ...query,
        fetchNextPage: query.fetchNextPage,
        remappedData
    }
}
